

























import Vue, { PropType } from 'vue';

// export type DataType = {
//   innerValue: string|number;
// }

export default Vue.extend({
  name: 'GPriceFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string>, required: true },
    value: { type: Number as PropType<number>, default: null },
    name: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    min: { type: Number as PropType<number>, default: 0 },
    max: { type: Number as PropType<number>, default: 999999999 },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
  },
  // data(): DataType {
  //   return {
  //     innerValue: this.value,
  //   };
  // },
  computed: {
    innerValue: {
      get(): number {
        return this.value;
      },
      set(val: number) {
        this.$emit('input', val);
      },
    },
  },
  // watch: {
  //   innerValue(val: number) {
  //     this.$emit('input', val);
  //   },
  // },
});
